export default "__VITE_ASSET__YdM2mmSN__"